
import { DynamicFilterController } from "../../filters/DynamicFilterController";

export default {
  data() {
    return {
      newFieldSearchValue: "",
      newFieldValue: null,
      newFieldOpen: false,
      groupJoinPrompt: null,
    };
  },
  props: {
    controller: {
      type: DynamicFilterController,
      required: true,
    },
  },
  methods: {
    removeFilter(filter) {
      const groupKey = filter.groupKey;

      this.controller.removeFilter(filter);

      if (!groupKey) return;

      // A one-member `any` group is equivalent to a plain filter -- collapse
      // it back rather than leave a bordered block around a single chip. A
      // one-member `none` group is kept: it is Example 1's exclusion clause
      // and is not equivalent to any plain filter.
      const remaining = this.controller.dynamicFilters.filter(
        (f) => f.groupKey === groupKey
      );
      if (remaining.length === 1 && remaining[0].groupMode !== "none") {
        this.controller.ungroup(remaining[0]);
      }
    },
    consoleLog() {
      console.log(this.controller.filterValues, this.controller);
    },
    selectNewField(fieldId) {
      const fieldOption = this.fieldOptions.find(
        (fieldOption) => fieldOption.field.id === fieldId
      );
      if (!fieldOption) return console.error("Field not found: " + fieldId);

      this.controller.addFilter(fieldOption.field);
      const newFilter =
        this.controller.dynamicFilters[
          this.controller.dynamicFilters.length - 1
        ];

      this.newFieldOpen = false;
      this.$nextTick(() => {
        this.newFieldSearchValue = "";
        this.newFieldValue = null;
      });

      this.maybeOfferGroupJoin(newFilter);
    },
    focusFieldSelect() {
      setTimeout(() => {
        this.$refs["field-select"].focus();
      }, 100);
    },
    // Group membership defaults to off (Decision 4) -- offer it rather than
    // silently grouping, so no existing user's saved URL changes meaning.
    maybeOfferGroupJoin(newFilter) {
      const root = this.controller.groupRoot(newFilter);
      if (!root) return;

      const candidate = this.controller.dynamicFilters.find(
        (f) =>
          f !== newFilter &&
          !f.groupKey &&
          this.controller.groupRoot(f) === root
      );
      if (!candidate) return;

      this.groupJoinPrompt = {
        newFilter,
        existingFilter: candidate,
        label: this.controller.model.getRelativeFieldLabel(root),
      };
    },
    acceptGroupJoin() {
      if (!this.groupJoinPrompt) return;

      this.controller.createGroup(
        [this.groupJoinPrompt.existingFilter, this.groupJoinPrompt.newFilter],
        "any"
      );
      this.groupJoinPrompt = null;
    },
    dismissGroupJoin() {
      this.groupJoinPrompt = null;
    },
    groupLabel(item) {
      const root = this.controller.groupRoot(item.filters[0]);
      return this.controller.model.getRelativeFieldLabel(root);
    },
    setGroupMode(item, mode) {
      item.filters.forEach((filter) => {
        filter.groupMode = mode;
      });
    },
  },
  computed: {
    fieldOptions() {
      const fieldsByLabel = this.controller.fieldOptions;

      // sort by label
      fieldsByLabel.sort((a, b) => (a.label < b.label ? -1 : 1));

      return fieldsByLabel;
    },
    selectOptions() {
      return this.fieldOptions.map((fieldOption) => ({
        text: fieldOption.label,
        value: fieldOption.field.id,
      }));
    },
    // Partitions dynamicFilters into standalone filters and groups (each
    // group rendered once, as a single bordered block of its members).
    displayItems() {
      const seenGroups = new Set();
      const items = [];

      this.controller.dynamicFilters.forEach((filter) => {
        if (!filter.groupKey) {
          items.push({ type: "filter", filter });
          return;
        }

        if (seenGroups.has(filter.groupKey)) return;
        seenGroups.add(filter.groupKey);

        items.push({
          type: "group",
          groupKey: filter.groupKey,
          filters: this.controller.dynamicFilters.filter(
            (f) => f.groupKey === filter.groupKey
          ),
        });
      });

      return items;
    },
  },
};
